import {ErrorCode} from "./error-code";

export class ErrorModel {

  public errorCode: string;
  public message: string;

  constructor(errorCode: ErrorCode, message: string) {
    this.errorCode = ErrorCode[errorCode];
    this.message = message;
  }
}
